export default __webpack_public_path__ + "static/media/Logo_lens-Barber-Shop-transperent-03.d5c2aac6.png";